import React from 'react';
import type { Tool } from '../../types/tools';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
export function ToolHowItWorks({
  tool
}: {
  tool: Tool;
}) {
  return <section aria-labelledby="how-heading" className="border-b border-hairline-soft bg-ink" data-id="element-1187" data-mp="22sb66i24z8qu">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-1188" data-mp="26ug2jojyyjh6">
        <SectionHeading eyebrow="How it works" headingId="how-heading" title={`How ${tool.name} works`} data-id="element-1189" data-mp="1a4fddofou0zc" />
        <ol className="mt-12 grid gap-4 md:grid-cols-3" data-id="element-1190" data-mp="1f277mp3t1z6p">
          {tool.steps.map((step, index) => <Reveal key={step.title} as="li" delay={index * 0.06} className="relative rounded-2xl border border-hairline bg-panel p-6" data-id="element-1191" data-mp="1j4c0hlmfirsa" data-mpi={index}>
              <span className="font-mono text-xs text-lime" data-id="element-1192" data-mp="1nwlkkl0v4xmn">STEP 0{index + 1}</span>
              <h3 className="mt-3 text-lg font-semibold tracking-[-0.015em] text-text-primary" data-id="element-1193" data-mp="rcwd3pd1t110">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-text-secondary" data-id="element-1194" data-mp="vd6kn6ghnzhz">{step.body}</p>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}